import cx from "classnames";
import { format, parseISO } from "date-fns";
import * as React from "react";
import { HiOutlineMailOpen } from "react-icons/hi";
import { MdOutlineEmail } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { talentStatuses } from "../../interfaces/resources/talent";
import { TalentStatusEventsProps } from "../../interfaces/resources/talentStatusEvents";
import { State } from "../../interfaces/state";
import { extractPageFromIri } from "../../services/api/helpers";
import { Tooltip } from "../Tooltip";
import styles from "./index.module.scss";

interface Props {
  talentStatusEvent: TalentStatusEventsProps;
}
export const LastEmailStatus: React.FC<Props> = ({ talentStatusEvent }): any => {
  const lastStatus = talentStatusEvent?.talent?.talentEmailStatuses?.reduce((acc, aes) => {
    if (aes.createdAt > acc.createdAt) {
      return aes;
    }
    return acc;
  }, talentStatusEvent?.talent?.talentEmailStatuses[0]);

  if (talentStatusEvent?.talent?.talentEmailStatuses && talentStatusEvent?.talent.talentEmailStatuses.length > 0) {
    return (
      lastStatus && (
        <div className={styles.headerItem}>
          <div className={styles.emailStatusContainer}>
            <Tooltip
              content={
                <div className={styles.tcCountTooltip}>
                  <div>
                    {lastStatus.status === "sent"
                      ? "Email envoyé"
                      : lastStatus.status === "open"
                      ? "Email ouvert"
                      : "Email cliqué"}
                    {" le "}
                    {format(parseISO(lastStatus.createdAt), "dd/MM")}
                  </div>
                </div>
              }
            >
              {lastStatus.status === "sent" ? (
                <MdOutlineEmail className={styles.emailIcon} />
              ) : (
                <HiOutlineMailOpen
                  className={cx(styles.emailIcon, { [styles.emailOpen]: lastStatus.status === "clicked" })}
                />
              )}
            </Tooltip>
          </div>
        </div>
      )
    );
  }
};

export const CallPendingTalents: React.FC = (): JSX.Element => {
  const currentUser = useSelector((state: State) => state.currentUser);
  const [talentStatusEvents, setTalentStatusEvents] = React.useState<TalentStatusEventsProps[]>([]);

  function filterLatestTalentStatusEvents(events: TalentStatusEventsProps[]): TalentStatusEventsProps[] {
    const latestEvents: any = {};

    events.forEach((event) => {
      if (!event.talent || !event.talent["@id"]) {
        return;
      }
      const talentId = event.talent["@id"];

      if (!latestEvents[talentId] || new Date(event.createdAt) > new Date(latestEvents[talentId].createdAt)) {
        latestEvents[talentId] = event;
      }
    });

    return Object.values(latestEvents);
  }
  React.useEffect(() => {
    if (!currentUser) {
      return;
    }
    if (Array.isArray(currentUser.talentStatusEvents)) {
      setTalentStatusEvents(filterLatestTalentStatusEvents(currentUser.talentStatusEvents));
    }
  }, [currentUser]);

  return (
    <div>
      <div className={styles.titleContainer}>
        <h2 className={styles.title}>Tes talents en attente de call</h2>
      </div>
      <div>
        {Array.isArray(talentStatusEvents) && talentStatusEvents.length ? (
          <ul>
            {talentStatusEvents.map((tse, i) => {
              const data = tse.data ? JSON.parse(tse.data) : null;
              return tse.talent ? (
                <li key={`${tse.talent["@id"]}-name-${i}`} className={styles.grid}>
                  <div className={styles.flexContainer}>
                    <LastEmailStatus talentStatusEvent={tse} />
                    <Link
                      to={extractPageFromIri("talents", tse.talent["@id"])}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.name}
                    >{`${tse.talent.firstname} ${tse.talent?.lastname}`}</Link>
                  </div>
                  <div className={styles.flexContainer}>
                    <div>
                      {tse.status === talentStatuses.callBooked
                        ? data && data.interview_at && data.interview_at.date
                          ? `Qualif le ${format(parseISO(data.interview_at.date), "dd/MM/yyyy")}`
                          : data && data.interview_at && !data.interview_at.date
                          ? `Qualif le ${format(parseISO(data.interview_at), "dd/MM/yyyy")}`
                          : null
                        : "Pas de date de qualif"}
                    </div>
                  </div>
                  <div className={styles.noteContainer}>{data && data.note ? data.note : null}</div>
                </li>
              ) : null;
            })}
          </ul>
        ) : (
          <div className={styles.emptyResults}>Aucun talent en attente</div>
        )}
      </div>
    </div>
  );
};
